import type { RouteRecordRaw } from "vue-router"
import { useApplicationStore } from "@versatile-credit-apply/sdk"

export const AffDecisionRoutes: RouteRecordRaw[] = [
  {
    name: "aff-apply-approved",
    path: "approved",
    component: () => import("./components/AffApproved.vue"),
  },
  {
    name: "aff-apply-prequalified",
    path: "prequalified",
    component: () => import("./components/AffPrequalified.vue"),
    meta: {
      next: "../application",
      step: "applicant",
    },
  },
  {
    name: "aff-apply-pending",
    path: "pending",
    component: () => import("./components/AffPending.vue"),
  },
  {
    name: "aff-apply-declined",
    path: "declined",
    component: () => import("./components/AffDeclined.vue"),
  },
  {
    name: "aff-apply-error",
    path: "error",
    component: () => import("./components/AffError.vue"),
  },
  {
    name: "aff-apply-no-offer",
    path: "nooffer",
    component: () => import("./components/AffNoOffer.vue"),
  },
]

export const AffApplyRoutes: RouteRecordRaw[] = [
  {
    name: "aff-apply-routes",
    path: "aff_standard",
    children: [
      {
        name: "aff-apply-start",
        path: "start/:mode",
        component: () => import("./pages/AffIntroPage.vue"),
        meta: {
          step: "applicant",
        },
      },
      {
        name: "aff-apply-decisions",
        path: "decision",
        component: () => import("./pages/AffDecisionPage.vue"),
        meta: {
          preventBack: true,
          step: "decision",
        },
        children: AffDecisionRoutes,
      },
      {
        name: "aff-terms",
        path: "terms",
        component: () => import("./pages/AffApplyTermsPage.vue"),
        meta: {
          next: () => {
            const store = useApplicationStore()
            return store.applyMode !== "full" ? "accept-offer" : "submit"
          },
          step: "terms",
        },
      },
    ],
  },
]
